import { handleResponse } from './client';

const DAEMON_BASE_URL = 'http://localhost:9998';

export async function getAuthStatus(): Promise<{ status: 'authorized' | 'unauthorized' | 'expired' | 'invalid' }> {
  try {
    const response = await fetch(`${DAEMON_BASE_URL}/auth/status`);
    return handleResponse(response);
  } catch (e) {
    if (e instanceof TypeError && e.message.includes('fetch')) {
      throw new Error('Could not connect to Repoburg Platform Daemon. Is it running?');
    }
    throw e;
  }
}

export async function initiateLogin(): Promise<{ loginUrl: string }> {
  const response = await fetch(`${DAEMON_BASE_URL}/auth/initiate`, {
    method: 'POST'
  });
  return handleResponse(response);
}